// extracted by mini-css-extract-plugin
module.exports = {"call_ringing":"styles_call_ringing__164IY","top":"styles_top__11I9M","ellipsis":"styles_ellipsis__3FZXc","bottom":"styles_bottom__32WsK"};